import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ProductModalState {
  isOpen: boolean;
  productId: number | null;
  initialAttributes: { [key: string]: string };
}

const initialState: ProductModalState = {
  isOpen: false,
  productId: null,
  initialAttributes: {},
};

// Unified payload type
export interface OpenProductModalPayload {
  productId: number;
  initialAttributes?: { [key: string]: string };
}

export const productModalSlice = createSlice({
  name: "productModal",
  initialState,
  reducers: {
    openProductModal: (
      state,
      action: PayloadAction<OpenProductModalPayload>
    ) => {
      state.isOpen = true;
      state.productId = action.payload.productId;
      state.initialAttributes = action.payload.initialAttributes || {};
    },
    closeProductModal: (state) => {
      state.isOpen = false;
      state.productId = null;
      state.initialAttributes = {};
    },
  },
});

export const { openProductModal, closeProductModal } =
  productModalSlice.actions;

export default productModalSlice.reducer;
